var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStnChaeviYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4966 11.7334V12.0083C23.4479 13.9831 22.8758 15.8303 21.9123 17.427L21.9023 17.4435L21.8937 17.4608C21.7588 17.729 21.5835 18.015 21.355 18.3187L21.3544 18.3194C19.2887 21.0746 16.8606 23.9079 14.9456 26.0555C13.9888 27.1286 13.1615 28.0289 12.5737 28.6607C12.3435 28.908 12.1501 29.1142 12 29.2734C11.8499 29.1142 11.6565 28.908 11.4263 28.6607C10.8385 28.0289 10.0112 27.1286 9.05439 26.0555C7.13938 23.9079 4.71131 21.0746 2.6456 18.3194L2.64504 18.3187C2.41647 18.015 2.24119 17.729 2.10634 17.4608L2.09767 17.4435L2.0877 17.427C1.0796 15.7565 0.5 13.8117 0.5 11.7334C0.5 5.53971 5.63728 0.5 11.9983 0.5C18.3593 0.5 23.4966 5.53971 23.4966 11.7334Z",
    fill: "#FFCC00",
    stroke: "#E7B800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8H16.1388L12.8124 12.1274H13.9876L11.5409 15.1618L7.67758 8H5L10.0369 17.0279L10.4653 17.7939H12.4014L12.7389 17.3846L17.37 11.7689H16.1685L19 8Z",
    fill: "#6CC3D5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStnChaeviYellow);
export default __webpack_public_path__ + "static/media/stn-chaevi-yellow.c755e45bd15aa570b002cdfe78f4ba08.svg";
export { ForwardRef as ReactComponent };